import React, { useState } from 'react';
import KatCizimPanel from '../KatCizimPanel';
import KatKarsiligGorunumPaylasim from '../KatKarsiligGorunumPaylasim';
import { BolumEtiketi } from '../BolumPaylasimDetay';

// v1.26.0 — Önerilen bir bölümün önizlemesi: bilgiler, mevcut paylaşımlar, kat planında ve görünümlerde
// işaretli konumu (bölüm vurgulanır).

interface OnizlemeBolum {
    bolumID: number; bolumAdi: string; bolumTipi: string | null; turu: string | null; m2: number; fiyat: number; birimFiyat: number;
    blokID: number | null; katID: number | null; xVal: number | null; yVal: number | null; not: string | null;
    blok: { blokAdi: string } | null; kat: { katAdi: string } | null;
    cephe1: { cepheAdi: string } | null; cephe2: { cepheAdi: string } | null; cephe3: { cepheAdi: string } | null; cephe4: { cepheAdi: string } | null;
    paylasimlar: { paylasimID: number; ortakID: number | null; muteahhitID: number | null; oranYuzde: number; ortak: { adSoyad: string } | null; muteahhit: { adSoyad: string } | null }[];
}
interface OnizlemeArsa {
    bloklar: { blokID: number; blokAdi: string; en: number | null; boy: number | null; katlar: { katID: number; katAdi: string; en: number | null; boy: number | null }[] }[];
    cepheler: { cepheAdi: string; yon: string | null }[];
    bolumler: OnizlemeBolum[];
}

const tl = (n: number) => `${n.toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺`;
const oranTop = (b: OnizlemeBolum) => b.paylasimlar.reduce((s, p) => s + p.oranYuzde, 0);

const BolumOnizlemeModal: React.FC<{ arsaId: number; arsa: OnizlemeArsa; bolumID: number; onKapat: () => void }> = ({ arsaId, arsa, bolumID, onKapat }) => {
    const [sekme, setSekme] = useState<'plan' | 'gorunum'>('plan');
    const b = arsa.bolumler.find(x => x.bolumID === bolumID);
    if (!b) return null;
    const blok = arsa.bloklar.find(x => x.blokID === b.blokID);
    const kat = blok?.katlar.find(x => x.katID === b.katID);
    const dolu = oranTop(b);
    const cepheler = [b.cephe1, b.cephe2, b.cephe3, b.cephe4].filter(Boolean).map(c => c!.cepheAdi).join(', ');

    return (
        <div className="kka-modal-overlay" style={{ zIndex: 10050 }} onClick={onKapat}>
            <div className="kka-modal" style={{ maxWidth: 1000, width: '96vw', maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                <div className="kka-modal-header">
                    <h3><i className="fas fa-door-open" style={{ color: '#cd6906', marginRight: 8 }}></i>{b.bolumAdi}{b.turu ? <span style={{ color: '#94a3b8', fontWeight: 600 }}> — {b.turu}</span> : null}</h3>
                    <button className="kka-modal-close" onClick={onKapat}><i className="fas fa-times"></i></button>
                </div>
                <div className="kka-modal-body">
                    <div className="kka-onizleme-grid">
                        {[
                            ['Blok / Kat', [b.blok?.blokAdi, b.kat?.katAdi].filter(Boolean).join(' / ') || '–'],
                            ['Tür / Tip', [b.turu, b.bolumTipi].filter(Boolean).join(' · ') || '–'],
                            ['m²', b.m2 ? `${b.m2.toLocaleString('tr-TR')} m²` : '–'],
                            ['Fiyat', b.fiyat ? tl(b.fiyat) : '–'],
                            ['Birim fiyat', b.birimFiyat ? `${tl(b.birimFiyat)}/m²` : '–'],
                            ['Cephe', cepheler || '–'],
                            ['Paylaşılan', `%${dolu.toLocaleString('tr-TR', { maximumFractionDigits: 2 })}`],
                            ['Boş pay', `%${Math.max(0, 100 - dolu).toLocaleString('tr-TR', { maximumFractionDigits: 2 })} · ${tl(b.fiyat * Math.max(0, 100 - dolu) / 100)}`],
                        ].map(([e, d]) => <div key={e}><div className="e">{e}</div><div className="d">{d}</div></div>)}
                    </div>
                    {b.not && <div style={{ fontSize: '0.84rem', color: '#475569', marginBottom: 10 }}><i className="fas fa-sticky-note" style={{ marginRight: 6, color: '#94a3b8' }}></i>{b.not}</div>}
                    {b.paylasimlar.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 6 }}>
                            <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#475569' }}>Mevcut paylaşımlar:</span>
                            {b.paylasimlar.map(p => (
                                <span key={p.paylasimID} className="kka-kaynak kural">{p.ortak?.adSoyad ?? p.muteahhit?.adSoyad ?? '–'} %{p.oranYuzde.toLocaleString('tr-TR', { maximumFractionDigits: 2 })}</span>
                            ))}
                        </div>
                    )}

                    <div className="kka-not-sekmeler" style={{ marginTop: 10 }}>
                        <button className={sekme === 'plan' ? 'aktif' : ''} onClick={() => setSekme('plan')}><i className="fas fa-map" style={{ marginRight: 6 }}></i>Kat planı</button>
                        <button className={sekme === 'gorunum' ? 'aktif' : ''} onClick={() => setSekme('gorunum')}><i className="fas fa-image" style={{ marginRight: 6 }}></i>Görünümler</button>
                    </div>
                    <div style={{ paddingTop: 10 }}>
                        {sekme === 'plan' ? (
                            !blok || !kat ? (
                                <div className="kka-empty">Bu bölümün blok / katı seçilmemiş; kat planında gösterilemiyor.</div>
                            ) : (
                                <>
                                    {(b.xVal == null || b.yVal == null) && (
                                        <div style={{ fontSize: '0.8rem', color: '#b45309', marginBottom: 6 }}>
                                            <i className="fas fa-exclamation-triangle" style={{ marginRight: 5 }}></i>Bölüm kat planında henüz yerleştirilmemiş (sol üstte görünür).
                                        </div>
                                    )}
                                    <KatCizimPanel
                                        key={kat.katID}
                                        katId={kat.katID}
                                        blokAdi={blok.blokAdi}
                                        katAdi={kat.katAdi}
                                        katEn={kat.en ?? blok.en}
                                        katBoy={kat.boy ?? blok.boy}
                                        arsaId={arsaId}
                                        readOnly
                                        cepheler={arsa.cepheler}
                                        bolumler={arsa.bolumler.filter(x => x.katID === kat.katID).map(x => ({
                                            bolumID: x.bolumID, bolumAdi: x.bolumAdi, xVal: x.xVal, yVal: x.yVal, bolumTipi: x.bolumTipi, fiyat: x.fiyat, m2: x.m2,
                                            paylasimlar: x.paylasimlar.map(p => ({ adSoyad: p.ortak?.adSoyad ?? p.muteahhit?.adSoyad ?? '–', oranYuzde: p.oranYuzde })),
                                        }))}
                                        pinIcerik={id => {
                                            const x = arsa.bolumler.find(y => y.bolumID === id)!;
                                            const hedef = id === bolumID;
                                            return (
                                                <div style={{ position: 'relative', opacity: hedef ? 1 : 0.45 }}>
                                                    {hedef && <span className="kka-vurgu-halka" />}
                                                    <BolumEtiketi ad={x.bolumAdi} oran={oranTop(x)} vurgulu={hedef} hedef={hedef} />
                                                </div>
                                            );
                                        }}
                                    />
                                </>
                            )
                        ) : (
                            <KatKarsiligGorunumPaylasim
                                arsaId={arsaId}
                                vurguBolumID={bolumID}
                                bolumler={arsa.bolumler.map(x => ({
                                    bolumID: x.bolumID, bolumAdi: x.bolumAdi, bolumTipi: x.bolumTipi, m2: x.m2, fiyat: x.fiyat,
                                    paylasimlar: x.paylasimlar.map(p => ({ paylasimID: p.paylasimID, ad: p.ortak?.adSoyad ?? p.muteahhit?.adSoyad ?? '–', tip: p.ortakID != null ? 'O' as const : 'M' as const, oranYuzde: p.oranYuzde })),
                                }))}
                                surukleniyor={false}
                                birakilamaz={() => true}
                                onBirak={() => { }}
                            />
                        )}
                    </div>
                </div>
                <div className="kka-modal-footer">
                    <button className="kka-btn-secondary" onClick={onKapat}>Kapat</button>
                </div>
            </div>
        </div>
    );
};

export default BolumOnizlemeModal;
